import { getFileBadge } from 'components/UploadHub/fileTypeBadges';

const escapeHtml = (value = '') => {
  const div = document.createElement('div');
  div.textContent = value;
  return div.innerHTML;
};

export interface EmailAttachment {
  url: string;
  fileName: string;
}

export const buildEmailAttachmentHtml = (files: EmailAttachment[] = []) => {
  if (files.length === 0) return '';
  const attachmentsHtml = files
    .map(({ url, fileName }) => {
      const badge = getFileBadge(fileName);
      return (
        `<table class="email-attachment-item" contenteditable="false" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;border:1px solid rgba(0,18,43,0.2);border-radius:5px;background:#f9f9f9;margin-bottom:8px;max-width:320px;width:100%;">` +
        `<tr>` +
        `<td style="padding:0px 0 3px 12px;width:24px; border: none;">` +
        `<span style="display:inline-block;width:24px;height:24px;line-height:24px;border-radius:4px;background:${badge.color};color:#fff;font-size:8px;font-weight:bold;text-align:center;">${badge.label}</span>` +
        `</td>` +
        `<td style="padding:3px 8px;overflow:hidden; border: none;">` +
        `<a href="${url}" target="_blank" rel="noreferrer" style="color:#00122b;text-decoration:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${escapeHtml(fileName)}</a>` +
        `</td>` +
        `<td class="email-attachment-remove-cell" style="padding:3px 12px 3px 0;width:20px;text-align:right; border: none;">` +
        `<a href="#" class="email-attachment-remove" contenteditable="false" style="color:#00122b;text-decoration:none;cursor:pointer;font-size:24px;">&times;</a>` +
        `</td>` +
        `</tr>` +
        `</table>`
      );
    })
    .join('');

  // Trailing empty paragraph gives the caret an editable line to land on right after the
  // attachment(s) instead of next to a contenteditable="false" block.
  return attachmentsHtml + '<p><br></p>';
};

// Drops the editing-only remove control before the HTML is persisted as the email that actually
// gets sent - CSS-based hiding isn't reliable enough since Gmail both ignores visibility/display
// on this element and still includes it in the text preview snippet.
export const stripEmailAttachmentControls = (html = '') => {
  if (!html) return html;
  const div = document.createElement('div');
  div.innerHTML = html;
  div.querySelectorAll('.email-attachment-remove-cell').forEach((cell) => cell.remove());
  return div.innerHTML;
};
